export default "__VITE_ASSET__Dida55rS__"